"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatNumber = void 0;
const formatNumber = (a, opts = {}) => `${opts.prefix ?? ''}${Intl.NumberFormat(opts.locale, {
    maximumFractionDigits: opts.maximumFractionDigits ?? 2,
    ...opts,
}).format(a)}${opts.suffix ?? ''}`;
exports.formatNumber = formatNumber;
